import { useListRecordsQuery } from '@platform/state/api';
import type { IRecordListModel } from '@platform/core/types';
import { useListParams } from '../useListParams';
import { quickBase } from './quickBaseParams';

/**
 * «N з M» швидких полів (прототип v4): N — записів у відборі списку, M — у тому самому відборі без швидких полів; кількості — з `total`
 * однієї сторінки списку (API списку застосовує й пошук). Поки вантажиться — undefined.
 */
export function useQuickCount(model: IRecordListModel, quick: Readonly<Record<string, string>>): { n?: number; base?: number } {
  const params = useListParams(model);
  const base = quickBase(params, quick);
  const one = { page: 1, pageSize: 10 as const, facets: false };
  const n = useListRecordsQuery({ ws: model.ws, rt: model.rt.key, params: { ...params, ...one } }).data?.total;
  const all = useListRecordsQuery({ ws: model.ws, rt: model.rt.key, params: { ...base, ...one } }).data?.total;
  return { n, base: all };
}
